var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg6Full(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 170,
    viewBox: "0 0 155 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.2455 123.848L51.2475 123.85C61.3908 136.149 76.8359 142.258 97.4795 142.258C115.091 142.258 128.936 138.106 138.949 129.74C148.986 121.355 153.972 109.048 153.972 92.9051C153.972 78.9742 150.156 68.4376 142.442 61.3924C134.736 54.355 123.225 50.8804 108.002 50.8804C95.8487 50.8804 86.042 53.5183 78.6283 58.8422C78.6904 51.7243 80.3011 46.0297 83.4159 41.7162C86.6987 37.2179 91.242 34.9699 97.1038 34.9699C99.6706 34.9699 101.769 35.4741 103.426 36.4508C105.078 37.4242 106.326 38.8867 107.166 40.8657L107.295 41.1704H107.626H148.587H149.087V40.6704V38.4156C149.087 28.079 144.099 19.2359 134.23 11.8977C124.478 4.55233 111.901 0.900391 96.5401 0.900391C76.5174 0.900391 61.419 6.99693 51.3409 19.2618C41.2782 31.5078 36.2896 49.8214 36.2896 74.1156C36.2896 94.9866 41.2564 111.583 51.2455 123.848ZM107.054 103.859L107.052 103.86C104.787 106.603 101.498 108 97.1038 108C92.5044 108 88.6996 106.135 85.6581 102.365C82.6189 98.4735 81.0905 94.046 81.0692 89.0649C81.9141 87.1917 83.5262 85.2798 85.9545 83.3371L85.9568 83.3353C88.4799 81.2928 91.7432 80.2525 95.7885 80.2525C100.318 80.2525 103.876 81.5952 106.521 84.2397L106.529 84.2478L106.537 84.2554C109.308 86.785 110.696 90.0299 110.696 94.0325C110.696 97.6683 109.488 100.938 107.054 103.859Z",
    stroke: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8196_8481",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 1,
    width: 118,
    height: 141
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.002 51.3804C138.315 51.3804 153.472 65.222 153.472 92.9051C153.472 108.939 148.524 121.089 138.628 129.357C128.733 137.624 115.016 141.758 97.4795 141.758C76.9364 141.758 61.6543 135.682 51.6332 123.532C41.7374 111.381 36.7896 94.9093 36.7896 74.1156C36.7896 25.6388 56.7064 1.40039 96.5401 1.40039C111.822 1.40039 124.286 5.03302 133.931 12.2983C143.702 19.5635 148.587 28.2693 148.587 38.4156V40.6704H107.626C105.872 36.5367 102.365 34.4699 97.1038 34.4699C91.0911 34.4699 86.3938 36.7872 83.0117 41.422C79.7548 45.9314 78.1264 51.8814 78.1264 59.272V59.8356C85.5169 54.1988 95.4753 51.3804 108.002 51.3804ZM97.1038 108.5C101.613 108.5 105.058 107.06 107.438 104.179C109.943 101.172 111.196 97.7904 111.196 94.0325C111.196 89.8988 109.755 86.5167 106.874 83.8862C104.118 81.1304 100.423 79.7525 95.7885 79.7525C91.6548 79.7525 88.2727 80.8172 85.6422 82.9467C83.1369 84.9509 81.4459 86.9551 80.569 88.9593C80.569 94.0951 82.1348 98.6672 85.2664 102.676C88.398 106.559 92.3438 108.5 97.1038 108.5Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8196_8481)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_8196_8481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.222 52.2484C28.363 45.6328 34.917 35.3002 36.7355 29.2993C39.3709 20.9583 46.0333 2.85305 51.5999 -2.8405C58.5582 -9.95744 77.7116 -8.51742 88.536 -7.30543C99.3604 -6.09345 123.312 8.77139 125.851 17.7593C128.391 26.7473 114.896 41.6665 103.773 46.6223C92.6505 51.5781 87.8527 38.1533 85.7704 37.0727C83.6881 35.9921 71.9674 32.8121 66.9947 36.5024C62.022 40.1927 53.2103 54.2771 45.5843 59.2854C37.9583 64.2938 38.081 58.864 33.222 52.2484Z",
    fill: "#3538CD"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3179 37.2234L61.1254 10.3569",
    stroke: "url(#paint0_linear_8196_8481)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.405 68.0471L149.213 41.1807",
    stroke: "url(#paint1_linear_8196_8481)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7051 67.9143L107.513 41.0479",
    stroke: "url(#paint2_linear_8196_8481)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7559 85.8079L78.5634 58.9414",
    stroke: "url(#paint3_linear_8196_8481)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0952 110.179L85.9028 83.3125",
    stroke: "url(#paint4_linear_8196_8481)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7285 132.314L105.536 105.447",
    stroke: "url(#paint5_linear_8196_8481)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5522 159.245L135.36 132.379",
    stroke: "url(#paint6_linear_8196_8481)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M114.821 100.462L150.629 73.5952",
    stroke: "url(#paint7_linear_8196_8481)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_8196_8481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.2121 78.2222C102.526 78.2222 117.683 92.0638 117.683 119.747C117.683 135.781 112.735 147.931 102.839 156.198C92.9432 164.466 79.2268 168.6 61.69 168.6C41.1468 168.6 25.8647 162.524 15.8437 150.374C5.94789 138.223 1 121.751 1 100.957C1 52.4806 20.9168 28.2422 60.7505 28.2422C76.0326 28.2422 88.4963 31.8748 98.1416 39.1401C107.912 46.4053 112.797 55.1111 112.797 65.2574V67.5122H71.8363C70.0826 63.3785 66.5753 61.3116 61.3142 61.3116C55.3016 61.3116 50.6042 63.629 47.2221 68.2638C43.9653 72.7732 42.3368 78.7232 42.3368 86.1138V86.6774C49.7274 81.0406 59.6858 78.2222 72.2121 78.2222ZM61.3142 135.342C65.8237 135.342 69.2684 133.902 71.6484 131.021C74.1537 128.014 75.4063 124.632 75.4063 120.874C75.4063 116.741 73.9658 113.358 71.0847 110.728C68.3289 107.972 64.6337 106.594 59.9989 106.594C55.8653 106.594 52.4832 107.659 49.8526 109.788C47.3474 111.793 45.6563 113.797 44.7795 115.801C44.7795 120.937 46.3453 125.509 49.4768 129.517C52.6084 133.401 56.5542 135.342 61.3142 135.342Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.456 150.689L15.4579 150.692C25.6012 162.991 41.0464 169.1 61.69 169.1C79.3018 169.1 93.146 164.948 103.16 156.582C113.196 148.197 118.183 135.889 118.183 119.747C118.183 105.816 114.367 95.2794 106.652 88.2342C98.9461 81.1968 87.4353 77.7222 72.2121 77.7222C60.0592 77.7222 50.2525 80.3601 42.8387 85.684C42.9008 78.5661 44.5116 72.8715 47.6264 68.558C50.9091 64.0597 55.4525 61.8116 61.3142 61.8116C63.881 61.8116 65.9793 62.3159 67.6367 63.2926C69.2886 64.266 70.5365 65.7285 71.376 67.7075L71.5053 68.0122H71.8363H112.797H113.297V67.5122V65.2574C113.297 54.9208 108.309 46.0777 98.4408 38.7395C88.6883 31.3941 76.1112 27.7422 60.7505 27.7422C40.7279 27.7422 25.6294 33.8387 15.5513 46.1036C5.48868 58.3496 0.5 76.6632 0.5 100.957C0.5 121.828 5.46682 138.424 15.456 150.689ZM71.2643 130.7L71.2629 130.702C68.9976 133.444 65.7085 134.842 61.3142 134.842C56.7149 134.842 52.9101 132.977 49.8686 129.207C46.8294 125.315 45.301 120.888 45.2797 115.907C46.1245 114.034 47.7366 112.122 50.165 110.179L50.1672 110.177C52.6903 108.135 55.9536 107.094 59.9989 107.094C64.528 107.094 68.0866 108.437 70.7312 111.082L70.7392 111.09L70.7476 111.097C73.5181 113.627 74.9063 116.872 74.9063 120.874C74.9063 124.51 73.6981 127.78 71.2643 130.7Z",
    stroke: "#111517"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8196_8481",
    x: -43.0852,
    y: -82.8552,
    width: 243.796,
    height: 218.645,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.2741,
    result: "effect1_foregroundBlur_8196_8481"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_8196_8481",
    x: -5.36842,
    y: 21.8738,
    width: 129.419,
    height: 153.094,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.68421
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8196_8481"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8196_8481",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8196_8481",
    x1: 26.513,
    y1: 37.2233,
    x2: 61.1254,
    y2: 10.3569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8196_8481",
    x1: 114.6,
    y1: 68.047,
    x2: 149.213,
    y2: 41.1807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8196_8481",
    x1: 72.9002,
    y1: 67.9142,
    x2: 107.513,
    y2: 41.0479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8196_8481",
    x1: 43.951,
    y1: 85.8078,
    x2: 78.5634,
    y2: 58.9414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8196_8481",
    x1: 51.2904,
    y1: 110.179,
    x2: 85.9027,
    y2: 83.3125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8196_8481",
    x1: 70.9237,
    y1: 132.314,
    x2: 105.536,
    y2: 105.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8196_8481",
    x1: 100.747,
    y1: 159.245,
    x2: 135.36,
    y2: 132.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8196_8481",
    x1: 116.016,
    y1: 100.462,
    x2: 150.629,
    y2: 73.5952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6Full);
export default __webpack_public_path__ + "static/media/6__full.e0b733329a80e0412713786444b1ba53.svg";
export { ForwardRef as ReactComponent };